<template>
  <div class="device-detail-open-card">
    <div class="table-bd">

      <div class="action-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right; margin-right: 16px">
            <el-button type="warning" round @click="addPwdCrad" v-if="funcView.device_detail_password_add">
              {{ $t('device_detail_password_card.she_zhi_kai_ji_mi_ma') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-list">
        <!--
          卡槽编号 cardSlot
          密码 rfid
          使用人 cardOwner
          联系电话 cardOwnerPhone
          状态 deviceCardState  dms_device_card_state
          操作
          action
        -->
        <ul class="table-head">
          <li class="ub-f1"></li>
          <li class="ub-f2">{{ $t('device_detail_password_card.ka_cao_bian_hao') }}</li>
          <li class="ub-f2">{{ $t('device_detail_password_card.mi_ma') }}</li>
          <li class="ub-f3">{{ $t('device_detail_password_card.chi_ka_ren') }}</li>
          <li class="ub-f2">{{ $t('Common.com_status') }}</li>
          <!-- <li class="ub-f1">状态</li> -->
          <li class="ub-f1"></li>
        </ul>
        <ul class="table-body">
          <template v-if="tableList.length > 0">
            <li class="line" v-for="(item,index) in tableList" :key="item.workRunId">
              <ul class="content">
                <li class="ub-f1">
                  {{index+1}}
                </li>
                <li class="ub-f2">
                  {{ item.cardSlot }}
                </li>
                <li class="ub-f2">
                  {{ item.rfid }}
                </li>
                <li class="ub-f3">
                  {{ item.cardOwner || '-' }} {{item.cardOwnerPhone}}
                </li>
                <li class="ub-f2">
                  {{ dms_boot_card_state[item.deviceCardState] || '-' }}
                </li>
                <li class="ub-f1"><i class="icon icon-bianji edit" v-if="funcView.device_detail_password_edit" @click="onChangeUser(item)"></i></li>
                <!-- <li class="ub-f1"></li> -->
                <!-- <li class="ub-f1">
                <el-button type="text" size="mini">查看详情</el-button>
              </li> -->
              </ul>
            </li>
          </template>
          <li class="no-data" v-else>{{ $t('Common.com_no_data') }}</li>
        </ul>
      </div>
    </div>
    <changeUser v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></changeUser>
    <bindOpenpwdDialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getTableList"></bindOpenpwdDialog>
  </div>
</template>

<script>
// import moment from 'moment';
import apis from '@/utils/apis';
import changeUser from './device_detail_openCard_changeUser.vue';
import bindOpenpwdDialog from './bindOpenpwdDialog.vue';

export default {
  name: 'openCard',
  props: {
    deviceInfo: {
      type: Object,
      default: () => ({}),
    },
    tabData: {
      type: Array,
      default: () => [],
    },
    isCharging: {
      type: Boolean,
      default: false,
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    isAutonomous: {
      type: Boolean,
      default: false,
    },
    isTraining: {
      type: Boolean,
      default: false,
    },
  },
  components: { changeUser, bindOpenpwdDialog },
  computed: {},
  data() {
    return {
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        bodyNum: '',
      },
      tableList: [],
      totalRows: null,

      dms_boot_card_state: {},
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  watch: {},
  // created() {
  //   // 不需要与视图交互的变量都定义在created这里
  //   this.refreshTimer = null;
  //   this.scrollProportion = 0;
  //   this.chart = null;
  //   this.chartView = null;
  //   this.ds = null;
  //   this.mapArr = [];
  // },
  mounted() {
    // this.getTableColumn();
    this.getFuncView('/other/device');
    this.getDictionary('dms_boot_card_state', (data) => {
      this.dms_boot_card_state = this.$transformDicValue(data.dms_boot_card_state);
    });
    this.getTableList();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.deviceId = this.deviceInfo.deviceId;
      this.$getJSON(apis.bootCardListForDevice, this.formSearch).then((res) => {
        this.tableList = res.data.cardList;
      });
    },
    // 更改使用人
    onChangeUser(row) {
      this.dialogModel.title = this.$t('device_detail_password_card.bian_ji_chi_ka_ren');
      // console.log(row);
      this.dialogModel.data = row;
      this.dialogModel.type = 'password';
      this.dialogVisible = true;
    },
    addPwdCrad() {
      this.dialogModel1 = { title: this.$t('device_detail_password_card.kai_ji_mi_ma'), row: this.deviceInfo };
      this.dialogVisible1 = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-open-card {
  .table-bd {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    .title {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
    }
    .table-list {
      margin-top: 24px;

      .table-head {
        height: 40px;
        display: flex;
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        li {
          line-height: 40px;
          font-size: 14px;
          font-weight: bold;
          color: $--color-text-secondary;
        }
      }
      .table-body {
        height: 500px;
        overflow-y: auto;
        .line {
          height: 70px;
          padding: 0 16px;
          &:nth-of-type(even) {
            background-color: #f8f9fa;
          }
          .content {
            height: 70px;
            line-height: 70px;
            display: flex;
            li {
              line-height: 70px;
              font-size: 14px;
              color: $--color-text-regular;
              .card-info {
                display: flex;
                align-items: center;
                img {
                  width: 30px;
                  height: 30px;
                }
                span {
                  margin-left: 24px;
                }
              }
            }
            .edit {
              color: $--color-primary;
              font-size: 12px;
              cursor: pointer;
            }
          }
        }
        .no-data {
          margin-top: 24px;
          height: 130px;
          text-align: center;
          line-height: 130px;
          font-size: 16px;
          color: #818181;
          background: #ffffff;
          border-radius: 16px;
        }
      }
    }
  }
}
</style>
